// Lightweight app context: state selection, language, first-run flag.
import { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEYS = { state: "lc_state", lang: "lc_lang", onboarded: "lc_onb" };
const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [state, setStateRaw] = useState(() => localStorage.getItem(KEYS.state) || "UP");
  const [lang, setLangRaw] = useState(() => localStorage.getItem(KEYS.lang) || "en");
  const [onboarded, setOnboarded] = useState(() => localStorage.getItem(KEYS.onboarded) === "1");

  const setState = useCallback((s) => { setStateRaw(s); localStorage.setItem(KEYS.state, s); }, [setStateRaw]);
  const setLang = useCallback((l) => { setLangRaw(l); localStorage.setItem(KEYS.lang, l); }, [setLangRaw]);
  const completeOnboarding = useCallback(() => { setOnboarded(true); localStorage.setItem(KEYS.onboarded, "1"); }, [setOnboarded]);

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  return (
    <AppCtx.Provider value={{ state, setState, lang, setLang, onboarded, completeOnboarding }}>
      {children}
    </AppCtx.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppCtx);
  if (!ctx) throw new Error("useApp must be used inside AppProvider");
  return ctx;
}
